import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faClipboard } from "@fortawesome/free-solid-svg-icons"

export const Clipboard = (props) => {
  return <FontAwesomeIcon faIcon={faClipboard} {...props} />
}
